import React from "react";
import { useAuth } from "../../utils/AuthContext";
import ProtectedRoute from "../../utils/ProtectedRoute";
import "./App.css";
import {
  Route,
  Routes,
  useLocation,
  matchPath,
  Navigate,
} from "react-router-dom";

// Pages
import Home from "./Pages/Home";
import CoursePage from "./Pages/CoursePage";
import Landing_Page from "./Pages/Landing_Page";
import Log from "./Pages/Log";
import RegisterPage from "./Pages/RegisterPage";
import DashboardStudent from "./Pages/DashboardStudent";
import Profile from "./Pages/Profile";
import Courses from "./Pages/Courses";
import Certificates from "./Pages/Certificates";
import Dashboard from "./Pages/Dashboard";
import Achievements from "./Pages/Achievements";
import AdminDashboard from "./Pages/AdminDashboard";
import AddCourses from "./Pages/AddCourses";
import AdminNav from "./Pages/AdminNav";
import AccessPlan from "./Pages/AccessPlan";
import Editingtool from "./Pages/Editingtool";
import RightSidebar from "./Pages/RightSidebar";
import AaasDashboard from "./Pages/AaasDashboard";
import RghtSdebar from "./Pages/RghtSdebar";
import StudentSdebar from "./Pages/StudentSdebar";
import Notification from "./Pages/Notification";
import ResetPassword from "./Pages/ResetPassword";
import Wishlist from "./Pages/Wishlist";
import CourseDetails from "./Pages/CourseDetails";
import About from "./Pages/About";
import ForgotPassword from "./Pages/ForgotPassword";
import TmsDashboard from "./TmsPages/TmsDashboard";
import Training from "./TmsPages/Training";
import TmsParticipants from "./TmsPages/TmsParticipants";
import PendingTraining from "./TmsPages/PendingTraining";
import AddParticipants from "./TmsPages/AddParticipants";
import UpcomingTraining from "./TmsPages/UpcomingTraining";
import DeclinedTraining from "./TmsPages/DeclinedTraining";
import CreateAssessment from "./TmsPages/CreateAssessment";
import ViewEvent from "./TmsPages/ViewEvent";
import Quiz from "./TmsPages/Quiz";
import SelfRegistration from "./TmsPages/SelfRegistration";
import TmsResult from "./TmsPages/TmsResult";
import BotComponent from "./BotComponent 1";
import Setting from "./Pages/Setting";
import ViewCertificate from "./Components/ViewCertificate";
import SettingsLayout from "./Components/SettingsLayout";
import { NotificationSettings } from "./Pages/NotificatonSettings";
import { Privacy } from "./Pages/Privacy";
import { GroupInvites } from "./Pages/GroupInvites";
import { ExportData } from "./Pages/ExportData";
import { DeleteAccount } from "./Pages/DeleteAcc";
import LMSMessages from "./Pages/LMSMessage";
import ProfilePage from "./Pages/ProfileNew";
import MembersPage from "./Pages/MemberPage";
import EditProfile from "./Pages/EditProfile";
import CreateCoursePage from "./Pages/CourseAdd";
import TimelineSection from "./Components/Profile Section/TimelineSection";
import GroupsPage2 from "./Pages/GroupPage";
import CreatedGroupPage from "./Pages/CreatedGroup";
import ChatComponent from "./Pages/MessageTest";
import AddCourseInfo from "./Components/AddCourseSection/AddCourseInfo";
import CreateGroupPage2 from "./Pages/CreateGroupPage2";
import FeedsPage from "./Pages/FeedsPage";
import MyCourses from "./Pages/MyCourses";
import Homeee from "./Homee";
import Reports from "./Pages/Reports";
import Membership from "./Pages/Membership";
import { useNavigate } from "react-router-dom";
function Kaasdev() {
  return <MainApp />;
}

function MainApp() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isAdminArea = location.pathname.includes("/db-shiksha/kaas/admin");
  const isStudentArea = location.pathname.includes("/db-shiksha/kaas/student");

  const publicRoutes = [
    "/log",
    "/registerPage",
    "/forgotPassword",
    "/resetPassword",
    "",
  ];
  const isAuthRoute = publicRoutes.some((route) => {
    const cleanPath = location.pathname
      .replace("/db-shiksha/kaas/admin", "")
      .replace("/db-shiksha/kaas/student", "")
      .replace("/db-shiksha/kaas", ""); // Safety for root-ish kaas paths
    return matchPath(route, cleanPath || "/");
  });

  if (auth.loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "#0a0a0a",
          color: "#D4AF37",
        }}
      >
        <h3>Initializing secure session...</h3>
      </div>
    );
  }

  return (
    <>
      <Routes>
        {/* Public Routes - Accessible from any prefix */}
        <Route path="" element={<Landing_Page />} />
        <Route path="login" element={<Log />} />
        <Route path="log" element={<Navigate to="../login" replace />} />
        <Route path="registerPage" element={<RegisterPage />} />
        <Route path="forgotPassword" element={<ForgotPassword />} />
        <Route path="resetPassword" element={<ResetPassword />} />
        <Route path="about" element={<About />} />

        {/* Dynamic Route Rendering based on Area */}
        {isStudentArea && (
          <>
            {/* Student Routes */}
            <Route
              path="home"
              element={
                <ProtectedRoute
                  allowedRoles={["Student", "Admin", "Instructor"]}
                >
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="coursePage"
              element={
                <ProtectedRoute
                  allowedRoles={["Student", "Admin", "Instructor"]}
                >
                  <CoursePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="dashboardStudent"
              element={
                <ProtectedRoute allowedRoles={["Student", "Admin"]}>
                  <DashboardStudent />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="courses"
              element={
                <ProtectedRoute>
                  <Courses />
                </ProtectedRoute>
              }
            />
            <Route
              path="wishlist"
              element={
                <ProtectedRoute>
                  <Wishlist />
                </ProtectedRoute>
              }
            />
            <Route
              path="course/:id"
              element={
                <ProtectedRoute>
                  <CourseDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="certificates"
              element={
                <ProtectedRoute>
                  <Certificates />
                </ProtectedRoute>
              }
            />
            <Route
              path="achievements"
              element={
                <ProtectedRoute>
                  <Achievements />
                </ProtectedRoute>
              }
            />
            <Route
              path="viewCertificate/:id"
              element={
                <ProtectedRoute>
                  <ViewCertificate />
                </ProtectedRoute>
              }
            />
            <Route
              path="myCourses"
              element={
                <ProtectedRoute>
                  <MyCourses />
                </ProtectedRoute>
              }
            />
            <Route
              path="membership"
              element={
                <ProtectedRoute allowedRoles={["Student"]}>
                  <Membership />
                </ProtectedRoute>
              }
            />
            <Route
              path="feeds"
              element={
                <ProtectedRoute>
                  <FeedsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="group"
              element={
                <ProtectedRoute>
                  <GroupsPage2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="group/:id"
              element={
                <ProtectedRoute>
                  <CreateGroupPage2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="textMessage/:id"
              element={
                <ProtectedRoute>
                  <ChatComponent />
                </ProtectedRoute>
              }
            />

            {/* Shared Layout Components (Legacy/Internal) */}
            <Route path="studentSidebar" element={<StudentSdebar />} />
            <Route path="rightSidebar" element={<RghtSdebar />} />

            {/* Common Profile/Settings in Student Area */}
            <Route
              path="settings"
              element={
                <ProtectedRoute>
                  <Setting />
                </ProtectedRoute>
              }
            />
            <Route
              path="lmsMessage"
              element={
                <ProtectedRoute>
                  <LMSMessages />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="timeline"
              element={
                <ProtectedRoute>
                  <TimelineSection />
                </ProtectedRoute>
              }
            />
            <Route
              path="memberPage"
              element={
                <ProtectedRoute>
                  <MembersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="editProfile"
              element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="settingsLayout"
              element={
                <ProtectedRoute>
                  <SettingsLayout />
                </ProtectedRoute>
              }
            />
            <Route
              path="notifications"
              element={
                <ProtectedRoute>
                  <NotificationSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="privacy"
              element={
                <ProtectedRoute>
                  <Privacy />
                </ProtectedRoute>
              }
            />
            <Route
              path="groupInvites"
              element={
                <ProtectedRoute>
                  <GroupInvites />
                </ProtectedRoute>
              }
            />
            <Route
              path="exportData"
              element={
                <ProtectedRoute>
                  <ExportData />
                </ProtectedRoute>
              }
            />
            <Route
              path="deleteAccount"
              element={
                <ProtectedRoute>
                  <DeleteAccount />
                </ProtectedRoute>
              }
            />
            <Route
              path="notification"
              element={
                <ProtectedRoute>
                  <Notification />
                </ProtectedRoute>
              }
            />
          </>
        )}

        {isAdminArea && (
          <>
            {/* Admin Dashboard Routes */}
            {/* LMS Admin Shell – one route per sidebar page ID */}
            <Route
              path="lmsAdminDashboard"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="tmsdashboard"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="user-management"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="admin-master"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-category"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-occupation"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-education"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-department"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-designation"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-division"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-subdivision"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="course-assignment"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="instructor-management"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="course-approval"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="group-management"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="reports-analytics"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="billing-payments"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="access-control"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="settings"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="profile"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Homeee />
                </ProtectedRoute>
              }
            />
            <Route
              path="adminDashboard"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="adminNav"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <AdminNav />
                </ProtectedRoute>
              }
            />
            <Route
              path="accessPlan"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <AccessPlan />
                </ProtectedRoute>
              }
            />
            <Route
              path="editingTool"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <Editingtool />
                </ProtectedRoute>
              }
            />
            <Route
              path="rightSidebar"
              element={
                <ProtectedRoute allowedRoles={["Admin"]}>
                  <RightSidebar />
                </ProtectedRoute>
              }
            />

            {/* Instructor/Course Creator Routes (Usually in Admin Area) */}
            <Route
              path="aaasDashboard"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <AaasDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="addCourses"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <AddCourses />
                </ProtectedRoute>
              }
            />
            <Route
              path="createCourse"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <CreateCoursePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="addCourseInfo/:id"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <AddCourseInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="reports"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="tmsDashboard"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <TmsDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="training"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <Training />
                </ProtectedRoute>
              }
            />
            <Route
              path="participants"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <TmsParticipants />
                </ProtectedRoute>
              }
            />
            <Route
              path="pendingTraining"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <PendingTraining />
                </ProtectedRoute>
              }
            />
            <Route
              path="addParticipants"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <AddParticipants />
                </ProtectedRoute>
              }
            />
            <Route
              path="upcomingTraining"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <UpcomingTraining />
                </ProtectedRoute>
              }
            />
            <Route
              path="declinedTraining"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <DeclinedTraining />
                </ProtectedRoute>
              }
            />
            <Route
              path="createAssessment"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <CreateAssessment />
                </ProtectedRoute>
              }
            />
            <Route
              path="viewEvent/:training_id"
              element={
                <ProtectedRoute allowedRoles={["Instructor", "Admin"]}>
                  <ViewEvent />
                </ProtectedRoute>
              }
            />
            <Route
              path="quiz/:quiz_id"
              element={
                <ProtectedRoute>
                  <Quiz />
                </ProtectedRoute>
              }
            />
            <Route
              path="selfRegistration/:training_id"
              element={
                <ProtectedRoute>
                  <SelfRegistration />
                </ProtectedRoute>
              }
            />
            <Route
              path="result"
              element={
                <ProtectedRoute>
                  <TmsResult />
                </ProtectedRoute>
              }
            />

            <Route
              path="notifications"
              element={
                <ProtectedRoute>
                  <NotificationSettings />
                </ProtectedRoute>
              }
            />
          </>
        )}

        {/* Catch-all for landing */}
        <Route path="*" element={<Landing_Page />} />
      </Routes>
      {!isAuthRoute && <BotComponent />}
    </>
  );
}

export default Kaasdev;
